import {getDisplayDateRange} from '../../utils/dates';
import {CAN_PAY_PAYMENT_STATUS, TRIP_CONFIG} from './constants';

const {CANCELLED, PAST, UPCOMING} = TRIP_CONFIG;

export const getCancelledTrips = (trips) =>
    trips.filter((trip) => trip?.bookingState === CANCELLED.STATE);

export const getPastTrips = (trips) =>
    trips.filter((trip) => trip?.bookingState === PAST.STATE);

export const getUpcomingTrips = (trips) =>
    trips.filter((trip) => trip?.bookingState === UPCOMING.STATE);

export const getDisplayLocation = (trip) => {
    const {booking} = trip || {};
    const address = booking?.listing?.address;
    let displayLocation = [];
    if (address?.city) {
        displayLocation.push(address.city);
    }
    if (address?.stateProvince) {
        displayLocation.push(address.stateProvince);
    }
    return displayLocation.join(', ');
};

export const getDisplayStayDates = ({locale, trip}) => {
    const {booking} = trip || {};
    const {periodOfStay} = booking || {};
    const {checkInDate, checkOutDate} = periodOfStay || {};
    return getDisplayDateRange(checkInDate, checkOutDate, locale);
};

export const getPaymentStatus = (trip) => {
    const {booking, bookingState} = trip || {};
    const {isPrimaryGuest} = booking || {};
    if (bookingState !== UPCOMING.STATE || !isPrimaryGuest) {
        return null;
    }

    const {priceDetails} = booking || {};
    const payments = priceDetails?.payments || [];
    const filteredPayment = payments.find(
        (payment) => payment.viewUrl && CAN_PAY_PAYMENT_STATUS[payment.status]
    );

    const paymentStatusObj = filteredPayment
        ? {
              paymentText: filteredPayment.title,
              isPaymentOverdue: filteredPayment.status === 'OVERDUE',
          }
        : null;

    return paymentStatusObj;
};

export const getTripStatusLabel = (trip) => {
    const {bookingState, stayDisplayStatus} = trip || {};
    const description = stayDisplayStatus?.description || '';
    return bookingState === UPCOMING.STATE ? description : '';
};
